import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form';
import autoBind from 'react-autobind';
import MultiLanguageInput, { languages } from 'src/components/misc/multi-language-input';
import { isBlank } from 'src/components/misc/validations';

class CancellationOptionsEditForm extends Component {
    constructor(props) {
        super(props);
        autoBind(this);

        this.state = {};
    }

    render() {
        const { handleSubmit, t } = this.props;

        return (
            <form className="form-horizontal" onSubmit={handleSubmit}>
                <div className="row">
                    <div className="col-md-12">
                        <Field
                            name="description"
                            placeholder={t('cancellations.description')}
                            label={`${t('cancellations.description')} *`}
                            t={t}
                            component={MultiLanguageInput}
                            componentType="renderInput"
                        />
                    </div>
                </div>
            </form>
        );
    }
}

const validate = (values, props) => {
    const { t } = props;
    const errors = {};

    errors.description = {};
    if (isBlank(values.description) || Object.values(values.description).every(value => isBlank(value))) {
        languages.forEach(language => {
            errors.description[language.code] = t('cancellations.error');
        });
    } else errors.description = null;

    return errors;
};

export default reduxForm({
    form: 'cancellationOptionsEditForm',
    validate,
})(CancellationOptionsEditForm);
